export default [
	// 绑定手机号页面
	{
		path: '/wx-invite-code',
		name: 'WxInviteCode',
		component: (resolve) => require(['@/components/WxInviteCode/index.vue'], resolve),
	},
	{
		path: '/wx-invite-code-result',
		name: 'WxInviteCodeResult',
		component: (resolve) => require(['@/components/WxInviteCode/Result.vue'], resolve),
	},
];



// WEBPACK FOOTER //
// ./src/router/modules/weixin.js